import React from "react";
import get from "lodash/get";
import { useTranslation } from "react-i18next";
import { useRillContext } from "../../rill/RillReact/share/base";

function View(props) {
  const { t } = useTranslation("auth");
  const { locals } = useRillContext();

  const email = get(locals, "user.email");
  return (
    <div id="login-wrapper">
      <img
        className="logo"
        src="/img/msb-logo-white.svg"
        alt={t("step1.logoAlt")}
      />

      <div className="Steps" data-step="2">
        <div className="step"></div>
        <div className="step"></div>
        <div className="step"></div>
        <div className="step"></div>
      </div>

      <div className="frame narrow">
        <div className="head">
          <h1 className="alt">{t("step1.title")}</h1>
        </div>

        <p className="centered-text small-text minus-top">
          {t("step1.confirmationSent", { email })}
        </p>

        <p className="centered-text small-text">
          {t("step1.checkSpam")}
          {email && (
            <span>
              {t("step1.resendPrompt")} <br />
              <a href={`/resend-verification/${email}`}>
                <b>{t("step1.resendLink")}</b>
              </a>
            </span>
          )}
        </p>
      </div>
    </div>
  );
}

const Step1 = (app) => {
  app.get("/step1", ({ res }, next) => {
    res.body = <View />;
  });
};

export default Step1;
